import { type MutationError, trpc } from '@/shared/api';

interface UseCancelPaymentOptions {
  /** 돌려준 promise 가 끝날 때까지 isPending 이 유지된다. */
  readonly onSuccess?: () => unknown;
  /**
   * 성공이든 오류든 요청이 끝나면 부른다 — 토스가 거절하면 서버가 FAILED 행을 남기고 오류를 던져 다시 불러올 일이 생긴다.
   * 돌려준 promise(재조회)가 끝날 때까지 isPending 이 유지된다.
   */
  readonly onSettled?: () => unknown;
}

interface CancelPaymentRequest {
  readonly paymentId: string;
  readonly amount: number;
  readonly reason: string;
}

interface UseCancelPaymentResult {
  readonly cancel: (request: CancelPaymentRequest) => void;
  readonly isPending: boolean;
  /** 서버 거절 문구(토스 메시지 포함) — 환불 폼이 보여 준다. */
  readonly error: MutationError | null;
  /** 지난 오류를 지운다 — 다른 요청을 시작할 때 옛 오류가 남지 않게. */
  readonly reset: () => void;
}

/** 운영자 부분 환불(paymentManagement.cancel). 확인창은 호출부가 띄운다. */
export const useCancelPayment = ({
  onSuccess,
  onSettled,
}: UseCancelPaymentOptions = {}): UseCancelPaymentResult => {
  const mutation = trpc.paymentManagement.cancel.useMutation({ onSuccess, onSettled });

  return {
    cancel: (request) => mutation.mutate(request),
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
};
